import { z } from 'zod';

const MenuItemSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  slug: z.string(),
  name: z.string(),
  icon: z.string().optional(),
  frontend_endpoint: z.string().optional(),
  created_by: z.number(),
  updated_by: z.number(),
});

const RoleItemSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  company_id: z.number(),
  role: z.string(),
  created_by: z.number(),
  updated_by: z.number(),
  menus: z.array(MenuItemSchema).optional(),
});

// --- List ---
export const RoleListSchema = z.array(RoleItemSchema);

export const parseRoleList = (responseBody) => {
  const result = RoleListSchema.safeParse(responseBody?.data);
  if (!result.success) {
    console.warn('[Schema] RoleList mismatch:', result.error.flatten());
    return responseBody;
  }
  return { ...responseBody, data: result.data };
};

// --- Detail ---
export const parseRoleDetail = (responseBody) => {
  const result = RoleItemSchema.safeParse(responseBody?.data);
  if (!result.success) {
    console.warn('[Schema] RoleDetail mismatch:', result.error.flatten());
    return responseBody;
  }
  return { ...responseBody, data: result.data };
};
